import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { get } from '../../utils/networking';

interface TeamsChannel {
  id: string;
  displayName: string;
}

interface TeamsTeam {
  id: string;
  displayName: string;
  channels: TeamsChannel[];
}

interface TeamsOAuthCallbackParams {
  code: string;
  state: string;
}

interface TeamsOAuthCallbackResponse {
  teams: TeamsTeam[];
  teamsWorkspaceId: number;
}

const handleTeamsOAuthCallback = async (params: TeamsOAuthCallbackParams): Promise<TeamsOAuthCallbackResponse> => {
  const query = new URLSearchParams({
    code: params.code,
    state: params.state,
  });
  return get<TeamsOAuthCallbackResponse>(
    `/api/integrations/teams/auth/callback?${query.toString()}`
  );
};

export const useHandleTeamsOAuthCallback = (
  options?: Omit<UseMutationOptions<TeamsOAuthCallbackResponse, Error, TeamsOAuthCallbackParams>, 'mutationFn'>
) => {
  return useMutation({
    mutationFn: handleTeamsOAuthCallback,
    ...options,
  });
};
